(function () {
'use strict';
var VL = window.VL; if (!VL) return;
var h = VL.h;
function lat1(s) { return String(s).replace(/[^\u0000-ÿ–—‘’“”•…€]/g, function (ch) { return ch.normalize('NFD').replace(/[̀-ͯ]/g, ''); }); }
function pad(n) { return ('0' + n).slice(-2); }
function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
function today() { return iso(new Date()); }
// Claves de VedicLife guardadas en este navegador (prefijo «vl:» en vl-core)
var KEYS = ['medita-fav', 'medita-log', 'supa-fav', 'supa-plan', 'kaala-place', 'equilibrio-res', 'camino-goals', 'camino-diario', 'fb-log'];
var MAX_GOALS = 10, MAX_NOTES = 200, MAX_NOTE = 2000;
var MODULES = [
  { n: 'Biblioteca de meditaciones', p: '/pages/meditaciones', t: 'Sin registro' },
  { n: 'Equilibrio personal y ambiental', p: '/pages/equilibrio', t: 'Sin registro' },
  { n: 'Vastu Shastra', p: '/pages/vastu-shastra', t: 'Con tu cuenta' },
  { n: 'Kaala Nirnaya', p: '/pages/kaala-nirnaya-shastra', t: 'Con tu cuenta' },
  { n: 'Supa Shastra · Ayurveda', p: '/pages/supa-shastra-ayurveda', t: 'Con tu cuenta' }
];

VL.register('camino', {
mount: function (mount, ctx) {
var root = ctx.root, c = ctx.c;
var base = root.getAttribute('data-vl-base') || '';
var titles = {};
if (window.VLD && VLD.medita) VLD.medita.items.forEach(function (it) { titles[it.id] = it.title; });
function tt(id) { return titles[id] || id; }

function read() {
  return {
    favs: VL.store.get('medita-fav', []) || [],
    log: VL.store.get('medita-log', {}) || {},
    goals: VL.store.get('camino-goals', []) || [],
    notes: VL.store.get('camino-diario', []) || [],
    eq: VL.store.get('equilibrio-res', []) || []
  };
}
function entries(log) {
  var out = [];
  Object.keys(log).forEach(function (id) { (log[id] || []).forEach(function (d) { out.push({ id: id, d: d }); }); });
  return out.sort(function (a, b) { return a.d < b.d ? 1 : a.d > b.d ? -1 : 0; });
}

function draw() {
  VL.clear(mount);
  var S = read(), E = entries(S.log);
  var last30 = {}, now = new Date();
  for (var i = 0; i < 30; i++) { var d = new Date(now); d.setDate(now.getDate() - i); last30[iso(d)] = true; }
  var days = {}; E.forEach(function (e) { if (last30[e.d]) days[e.d] = (days[e.d] || 0) + 1; });

  // Aviso de almacenamiento
  mount.appendChild(h('div', { class: 'vl-panel' },
    h('p', { class: 'vl-lead', text: 'Tu resumen personal de VedicLife: favoritas, prácticas, objetivos y diario.' }),
    h('p', { class: 'vl-alert vl-alert--info', text: 'Por ahora todo se guarda solo en este navegador. Si cambias de dispositivo o borras los datos del navegador, no lo verás. La sincronización con tu cuenta gratuita llegará en una fase posterior.' })));

  // Resumen
  mount.appendChild(h('div', { class: 'vl-panel' },
    h('h2', { text: 'Resumen' }),
    h('ul', null,
      h('li', { text: S.favs.length + (S.favs.length === 1 ? ' meditación favorita' : ' meditaciones favoritas') }),
      h('li', { text: E.length + (E.length === 1 ? ' práctica anotada' : ' prácticas anotadas') }),
      h('li', { text: Object.keys(days).length + ' de los últimos 30 días con práctica' })),
    cal(days)));

  // Favoritas
  var fp = h('div', { class: 'vl-panel' }, h('h2', { text: 'Meditaciones favoritas' }));
  if (!S.favs.length) fp.appendChild(h('p', { class: 'vl-note' }, 'Aún no tienes favoritas. Puedes marcarlas en la ', h('a', { href: base + '/pages/meditaciones', text: 'biblioteca' }), '.'));
  else fp.appendChild(h('ul', null, S.favs.map(function (id) { return h('li', null, h('a', { href: base + '/pages/meditaciones#' + id, text: tt(id) })); })));
  mount.appendChild(fp);

  // Historial
  var hp = h('div', { class: 'vl-panel' }, h('h2', { text: 'Prácticas recientes' }));
  if (!E.length) hp.appendChild(h('p', { class: 'vl-note', text: 'Cuando pulses «Anotar práctica de hoy» en una ficha, aparecerá aquí.' }));
  else hp.appendChild(h('ul', null, E.slice(0, 15).map(function (e) { return h('li', null, VL.fmtDate(new Date(e.d + 'T12:00:00'), 'es') + ' · ', h('a', { href: base + '/pages/meditaciones#' + e.id, text: tt(e.id) })); })));
  mount.appendChild(hp);

  // Objetivos
  var gp = h('div', { class: 'vl-panel' }, h('h2', { text: 'Mis objetivos' }), h('p', { class: 'vl-note', text: 'Objetivos breves y alcanzables, por ejemplo «cinco minutos de respiración antes de dormir». Máximo ' + MAX_GOALS + '.' }));
  var gl = h('ul', { class: 'vl-goals' });
  S.goals.forEach(function (g, i) {
    var id = VL.uid('g');
    var cb = h('input', { type: 'checkbox', id: id, checked: g.done, onchange: function () { S.goals[i].done = cb.checked; VL.store.set('camino-goals', S.goals); } });
    gl.appendChild(h('li', null, h('label', { for: id }, cb, ' ' + g.t), ' ', h('button', { type: 'button', class: 'vl-btn vl-btn--ghost vl-btn--sm', 'aria-label': 'Quitar el objetivo: ' + g.t, onclick: function () { S.goals.splice(i, 1); VL.store.set('camino-goals', S.goals); draw(); } }, 'Quitar')));
  });
  gp.appendChild(gl);
  if (S.goals.length < MAX_GOALS) {
    var gid = VL.uid('gn');
    var gi = h('input', { type: 'text', id: gid, maxlength: '140', placeholder: 'Nuevo objetivo' });
    gp.appendChild(h('form', { class: 'vl-row', onsubmit: function (e) { e.preventDefault(); var t = gi.value.trim(); if (!t) return; S.goals.push({ t: t.slice(0, 140), done: false }); VL.store.set('camino-goals', S.goals); draw(); VL.announce(root, 'Objetivo añadido', 'ok'); } },
      h('div', { class: 'vl-field' }, h('label', { for: gid, text: 'Añadir objetivo' }), gi),
      h('div', { class: 'vl-actions' }, h('button', { type: 'submit', class: 'vl-btn vl-btn--sm', text: 'Añadir' }))));
  }
  mount.appendChild(gp);

  // Equilibrio
  var ep = h('div', { class: 'vl-panel' }, h('h2', { text: 'Repasos de equilibrio' }));
  if (!S.eq.length) ep.appendChild(h('p', { class: 'vl-note' }, 'Aún no has guardado ningún repaso. ', h('a', { href: base + '/pages/equilibrio', text: 'Hacer el repaso de equilibrio' }), '.'));
  else {
    var A = VL.EQ_AREAS, L = VL.EQ_LEVEL;
    ep.appendChild(h('ul', null, S.eq.slice().reverse().slice(0, 6).map(function (r) {
      var pr = A ? A.filter(function (a) { return r.r[a.k] === 2; }).map(function (a) { return a.n.toLowerCase(); }) : [];
      return h('li', { text: VL.fmtDate(new Date(r.d + 'T12:00:00'), 'es') + ' · ' + (pr.length ? 'Prioridades: ' + pr.join(', ') : 'Sin prioridades marcadas') });
    })));
  }
  mount.appendChild(ep);

  // Diario
  var dp = h('div', { class: 'vl-panel' }, h('h2', { text: 'Diario personal (opcional)' }),
    h('p', { class: 'vl-note', text: 'Lo que escribas se queda solo en este navegador: no se envía a ShivaRam ni a nadie, y no se incluye en el PDF salvo que lo marques. Cualquiera que use este navegador podría leerlo.' }));
  var did = VL.uid('d');
  var ta = h('textarea', { id: did, rows: '4', maxlength: String(MAX_NOTE) });
  dp.appendChild(h('form', { onsubmit: function (e) { e.preventDefault(); var t = ta.value.trim(); if (!t) return; S.notes.push({ d: today(), t: t.slice(0, MAX_NOTE) }); VL.store.set('camino-diario', S.notes.slice(-MAX_NOTES)); draw(); VL.announce(root, 'Entrada guardada', 'ok'); } },
    h('div', { class: 'vl-field' }, h('label', { for: did, text: 'Nueva entrada de hoy' }), ta),
    h('div', { class: 'vl-actions' }, h('button', { type: 'submit', class: 'vl-btn vl-btn--sm', text: 'Guardar entrada' }))));
  if (S.notes.length) {
    var det = h('details', { class: 'vl-gloss' }, h('summary', { text: 'Ver mis ' + S.notes.length + (S.notes.length === 1 ? ' entrada' : ' entradas') }));
    S.notes.slice().reverse().forEach(function (n, j) {
      var idx = S.notes.length - 1 - j;
      det.appendChild(h('div', { class: 'vl-x' }, h('p', { class: 'vl-note', text: VL.fmtDate(new Date(n.d + 'T12:00:00'), 'es') }), h('p', { text: n.t }),
        h('button', { type: 'button', class: 'vl-btn vl-btn--ghost vl-btn--sm', onclick: function () { S.notes.splice(idx, 1); VL.store.set('camino-diario', S.notes); draw(); } }, 'Borrar esta entrada')));
    });
    dp.appendChild(det);
  }
  mount.appendChild(dp);

  // Informe y privacidad
  var incl = h('input', { type: 'checkbox', id: VL.uid('inc') });
  var conf = h('p', { class: 'vl-note', 'aria-live': 'polite' });
  var armed = false;
  var del = h('button', { type: 'button', class: 'vl-btn vl-btn--ghost vl-btn--sm', onclick: function () {
    if (!armed) { armed = true; del.textContent = 'Pulsa otra vez para borrar todo'; conf.textContent = 'Se borrarán favoritas, prácticas, objetivos, diario, repasos y preferencias de VedicLife de este navegador.'; return; }
    KEYS.forEach(function (k) { VL.store.del(k); }); armed = false; draw(); VL.announce(root, 'Datos de VedicLife borrados de este navegador', 'ok');
  } }, 'Borrar mis datos de este navegador');
  mount.appendChild(h('div', { class: 'vl-panel' }, h('h2', { text: 'Informe y privacidad' }),
    h('div', { class: 'vl-field' }, h('label', { for: incl.id }, incl, ' Incluir el diario en el PDF')),
    h('div', { class: 'vl-actions' },
      h('button', { type: 'button', class: 'vl-btn vl-btn--sm', onclick: function () { pdf(incl.checked); } }, 'Descargar informe PDF'),
      h('button', { type: 'button', class: 'vl-btn vl-btn--ghost vl-btn--sm', onclick: exportJson }, 'Exportar mis datos (JSON)'),
      del),
    conf));

  // Módulos
  mount.appendChild(h('div', { class: 'vl-panel' }, h('h2', { text: 'Herramientas de VedicLife' }),
    h('ul', null, MODULES.map(function (m) { return h('li', null, h('a', { href: base + m.p, text: m.n }), ' · ' + m.t); }))));
}

function cal(days) {
  var wrap = h('div', { class: 'vl-cal', role: 'img', 'aria-label': 'Días con práctica en los últimos 28 días: ' + Object.keys(days).length });
  var now = new Date();
  for (var i = 27; i >= 0; i--) {
    var d = new Date(now); d.setDate(now.getDate() - i); var k = iso(d);
    wrap.appendChild(h('span', { class: 'vl-cal__d' + (days[k] ? ' is-on' : ''), title: k + (days[k] ? ' · practicado' : '') }));
  }
  return h('div', null, h('p', { class: 'vl-note', text: 'Últimos 28 días (cada cuadro es un día; dorado = practicado).' }), wrap);
}

function exportJson() {
  var data = {}; KEYS.forEach(function (k) { var v = VL.store.get(k, null); if (v !== null) data[k] = v; });
  var blob = new Blob([JSON.stringify({ exportado: new Date().toISOString(), origen: 'VedicLife OS · este navegador', datos: data }, null, 2)], { type: 'application/json' });
  var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'vediclife-mis-datos-' + today() + '.json';
  document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 500);
  VL.announce(root, 'Datos exportados', 'ok');
}

function pdf(withDiary) {
  try {
    var S = read(), E = entries(S.log);
    var pc = VL.translator(VL.COMMON, 'es');
    var doc = new VL.PDFDoc({ title: 'Mi camino en VedicLife', footer: pc('disclaimerShort'), pageLabel: pc('page') });
    var txt0 = doc.txt; doc.txt = function (x, y, s, size, bold, rgb) { return txt0.call(this, x, y, lat1(s), size, bold, rgb); };
    doc.h1('Mi camino en VedicLife');
    doc.p(pc('generated', { date: VL.fmtDate(new Date(), 'es') }) + ' · Datos de este navegador', { size: 9.5, rgb: '0.35 0.38 0.45' });
    doc.h2('Resumen');
    doc.bullets([S.favs.length + ' meditaciones favoritas', E.length + ' prácticas anotadas']);
    doc.h2('Meditaciones favoritas');
    doc.bullets(S.favs.length ? S.favs.map(tt) : ['Ninguna todavía']);
    doc.h2('Prácticas recientes');
    doc.bullets(E.length ? E.slice(0, 30).map(function (e) { return e.d + ' · ' + tt(e.id); }) : ['Ninguna todavía']);
    doc.h2('Objetivos');
    doc.bullets(S.goals.length ? S.goals.map(function (g) { return (g.done ? '[hecho] ' : '[pendiente] ') + g.t; }) : ['Ninguno todavía']);
    if (S.eq.length && VL.EQ_AREAS) {
      doc.h2('Repasos de equilibrio');
      doc.bullets(S.eq.slice().reverse().slice(0, 6).map(function (r) { return r.d + ' · ' + VL.EQ_AREAS.map(function (a) { return a.n + ': ' + VL.EQ_LEVEL[r.r[a.k]]; }).join('; '); }), { size: 9 });
    }
    if (withDiary && S.notes.length) { doc.h2('Diario'); S.notes.forEach(function (n) { doc.p(n.d, { size: 9, bold: true }); doc.p(n.t, { size: 9.5 }); }); }
    doc.box('Contenido cultural y de bienestar general. No sustituye la atención médica ni psicológica.');
    VL.downloadPDF(doc, 'mi-camino-' + today() + '.pdf');
    VL.announce(root, c('pdfOk'), 'ok');
  } catch (e) { if (window.console) console.error(e); VL.announce(root, c('pdfFail'), 'error'); }
}

draw();
}
});
if (VL.boot) VL.boot();
})();
